/** @jsx jsx */
import { jsx } from '@emotion/react';
import { PureComponent } from 'react';
import PropTypes from 'prop-types';

import { plain } from './logo.css';

const ratio = 37 / 49;

export default class PlainLogo extends PureComponent {
  static propTypes = {
    small: PropTypes.bool,
  };
  static defaultProps = {
    small: false,
  };
  render() {
    const height = this.props.small ? 24 : 36;
    const box = {
      height,
      width: Math.round(height / ratio),
    };
    return (
      <svg {...box} css={plain} viewBox="0 0 49 37">
        <path
          d="M41.57 6.52l-.1-.1h-.1l-7.09-3.67h-.18l-.15-.06h-.19a5 5 0 0 0-1.54-.25 4.91 4.91 0 0 0-1 .1 14.62 14.62 0 0 0-15.92 0 4.9 4.9 0 0 0-1-.1 5 5 0 0 0-1.54.25h-.08l-.19.06-.18.09L5.2 6.35h-.1l-.1.07h-.05c-5 3.22-5.17 7-4.78 9.07l.93 9.07v.28A8 8 0 0 0 9 31.49h.4l.6-.07a7.88 7.88 0 0 0 1.5-.23 1.57 1.57 0 0 1 1.68.58 12.37 12.37 0 0 0 20.18 0 1.57 1.57 0 0 1 1.64-.56 7.88 7.88 0 0 0 1.5.23h1.02a8 8 0 0 0 7.86-6.54v-.2l.94-9.15c.42-2.02.25-5.81-4.75-9.03z"
          fill="#fff"
        />
        <circle cx="28.16" cy="16.86" r="2.09" fill="#ed017f" />
        <circle cx="18.49" cy="16.86" r="2.09" fill="#73ae39" />
        <circle cx="27.59" cy="26.18" r=".57" fill="#010101" />
        <circle cx="29.17" cy="27.48" r=".57" fill="#010101" />
        <circle cx="27.43" cy="28.62" r=".57" fill="#010101" />
        <circle cx="18.89" cy="26.18" r=".57" fill="#010101" />
        <circle cx="17.32" cy="27.48" r=".57" fill="#010101" />
        <circle cx="19.06" cy="28.62" r=".57" fill="#010101" />
        <path
          d="M40.29 8.52l-7.1-3.68-.19-.07a2.59 2.59 0 0 0-.81-.13 2.55 2.55 0 0 0-1.36.39 12.24 12.24 0 0 0-15.22 0 2.55 2.55 0 0 0-1.36-.39 2.59 2.59 0 0 0-.81.13h-.09L6.29 8.42l-.09.05c-3.71 2.39-4.08 5-3.72 6.74l.93 9.21v.09A5.63 5.63 0 0 0 9 29.13H9.89a5.67 5.67 0 0 0 4-2v-.05l.45 1.71v.14a9.78 9.78 0 0 0 17.79-.06v-.07l.45-1.72a5.66 5.66 0 0 0 4 2H37.47a5.63 5.63 0 0 0 5.53-4.6l1-9.27c.37-1.72 0-4.3-3.71-6.69zm-26.86 2.14A16 16 0 0 0 12 15.83a15.18 15.18 0 0 0 .49 5.8 7.75 7.75 0 0 1 .32 1.52 3.28 3.28 0 0 1-.78 2.49 3.33 3.33 0 0 1-2.37 1.18h-.57a3.34 3.34 0 0 1-3.47-2.69l-.94-9.19v-.13c-.33-1.53.56-3 2.67-4.37l6.84-3.54a.3.3 0 0 1 .27.11.28.28 0 0 1 .06.25 21.16 21.16 0 0 1-1.09 3.4zm9.81 21.66a7.73 7.73 0 0 1-2.77-.52 10 10 0 0 0 2.77-1.32A10 10 0 0 0 26 31.8a7.73 7.73 0 0 1-2.76.52zM31.75 21a9.88 9.88 0 0 0-.4 1.92L30 28.07a6.29 6.29 0 0 1-1.32 2 9.47 9.47 0 0 1-4.29-1.54l.94-.67a1.2 1.2 0 0 0 .54-1l.13-1.09a1.46 1.46 0 0 0-1.59-1.28H22a1.46 1.46 0 0 0-1.59 1.28l.16 1.12a1.19 1.19 0 0 0 .51.94l.92.71a9.61 9.61 0 0 1-4.24 1.51 6.29 6.29 0 0 1-1.3-1.93l-1.37-5.2a9.88 9.88 0 0 0-.4-1.92 13.12 13.12 0 0 1-.4-5.06 14.08 14.08 0 0 1 1.23-4.44 23.2 23.2 0 0 0 1.23-3.74 2.59 2.59 0 0 0 0-.75 9.94 9.94 0 0 1 12.82 0 2.59 2.59 0 0 0 0 .75 23.21 23.21 0 0 0 1.23 3.74 14.08 14.08 0 0 1 1.23 4.44 13.12 13.12 0 0 1-.27 5.06zm10-6.16l-1 9.32a3.36 3.36 0 0 1-3.47 2.69h-.57a3.33 3.33 0 0 1-2.37-1.18 3.28 3.28 0 0 1-.78-2.49 7.75 7.75 0 0 1 .32-1.52 15.18 15.18 0 0 0 .49-5.8 16 16 0 0 0-1.39-5.17 21.16 21.16 0 0 1-1.12-3.37.28.28 0 0 1 .14-.28.3.3 0 0 1 .23-.12l6.87 3.5c2.1 1.41 3 2.88 2.67 4.42z"
          fill="#010101"
        />
      </svg>
    );
  }
}
